import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Service } from '../../class/service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  
  data = {
    username:'', password:''
  };		
  message = "";
	success = true;
	isLoad = false;

  constructor(
    private router: Router, 
		private service: Service 
  ) { }

  ngOnInit() {
    setTimeout(() => { this.success = false; }, 500);
  }

  FormSubmit(){
		this.isLoad = true;
		this.service.LOGIN(this.data).subscribe(res => {
			if(res){
				this.success = true;
				let link = ['/dashboard'];
				this.router.navigate(link);
			}else{
				this.isLoad = false;
				this.message = "Usuario y contraseña incorrecta"; 
			}
		}, err => {
			this.isLoad = false;
			this.message = "Usuario y contraseña incorrecta";
		});
	}

}


// WEBPACK FOOTER //
// ./src/app/component/login/login.component.ts